// English translations

const messages = {
    // Navbar
    navbar_admin_portal: 'Admin Portal',
    navbar_consumer_search: 'Consumer Search',
    navbar_language_choose_language: 'Choose language',
    navbar_market_choose_market: 'Choose market',

    // Home page
    homepage_welcome: 'Welcome to Admin Portal',
    homepage_not_allowed: 'You are not allowed to use this application.',
    homepage_search_btn: 'Consumer Search',
    homepage_login_btn: 'Login',
    homepage_logout_btn: 'Logout',

    // Search page
    searchpage_no_consumers_found: 'No consumers found.',
    searchpage_section_person: 'Person',
    searchpage_section_address: 'Address',
    searchpage_btn_search: 'Search',
    searchpage_btn_clear: 'Clear',
    searchpage_field_first_name: 'First name',
    searchpage_field_last_name: 'Last name',
    searchpage_field_dob: 'Date of birth (DD-MM-YYYY)',
    searchpage_field_email: 'Email address',
    searchpage_field_phone: 'Phone number',
    searchpage_field_address: 'Address',
    searchpage_field_city: 'City',
    searchpage_field_postal: 'Postal code',
    searchpage_invalid_date: 'Invalid date format. (DD-MM-YYYY)',
    searchpage_invalid_phone: 'Invalid phone number.',
    searchpage_invalid_wildcard:
        'Invalid wildcard (*) usage. Single wildcard allowed when used alone.',
    searchpage_column_first_name: 'First Name',
    searchpage_column_last_name: 'Last Name',
    searchpage_column_address: 'Address',
    searchpage_column_dob: 'Date of Birth',
    searchpage_column_email: 'Email',
    searchpage_column_phone: 'Phone Number',
    searchpage_column_actions: 'Actions',
    searchpage_menu_view_profile: 'View Profile',
    searchpage_menu_age_verification: 'Age Verification',
    searchpage_menu_marketing_prefs: 'Marketing Preferences',
    searchpage_menu_password_reset: 'Password Reset',
    searchpage_menu_consumer_delete: 'Consumer Delete',

    // Consumer page: tab names
    consumerpage_tab_system: 'System',
    consumerpage_tab_personal: 'Personal',
    consumerpage_tab_address: 'Address Data',
    consumerpage_tab_marketing_prefs: 'Marketing Preferences',
    consumerpage_tab_age_verification: 'Age Verification',

    // Consumer page: action buttons
    consumerpage_action_btn_edit: 'Edit',
    consumerpage_action_btn_save: 'Save',
    consumerpage_action_btn_cancel: 'Cancel',
    consumerpage_action_btn_reset_password: 'Reset Password',
    consumerpage_action_btn_delete_consumer: 'Delete Consumer',
    consumerpage_action_btn_set_hav_status: 'Set HAV Status',

    // Consumer page: validation errors
    consumerpage_error_required: 'Field is required.',
    consumerpage_error_email: 'Invalid email.',
    consumerpage_error_phone: 'Invalid phone number.',
    consumerpage_error_city: 'Invalid city.',
    consumerpage_error_postal: 'Invalid postal code.',

    // Consumer page: System tab
    consumerpage_system_field_consumer_id: 'Consumer ID',
    consumerpage_system_field_created: 'Created',
    consumerpage_system_field_registered: 'Registered',
    consumerpage_system_field_registration_time: 'Registration Time',
    consumerpage_system_field_login_allowed: 'Login Allowed',
    consumerpage_system_field_last_login: 'Last Login',
    consumerpage_system_field_last_updated: 'Last Updated',
    consumerpage_system_field_last_updated_by: 'Last Updated By',

    // Consumer page: Personal tab
    consumerpage_personal_field_first_name: 'First Name',
    consumerpage_personal_field_last_name: 'Last Name',
    consumerpage_personal_field_dob: 'Date of Birth',
    consumerpage_personal_field_gender: 'Gender',
    consumerpage_personal_field_email: 'Email',
    consumerpage_personal_field_language: 'Language',
    consumerpage_personal_field_home_country: 'Home Country',
    consumerpage_personal_field_mobile_phone: 'Mobile Phone',
    consumerpage_personal_field_home_phone: 'Home Phone',
    consumerpage_personal_field_mobile_verification_status:
        'Mobile Number Verification Status',
    consumerpage_personal_field_mobile_verification_date:
        'Mobile Number Verification Date',

    // Consumer page: Address tab
    consumerpage_address_field_addr_type: 'Address Type',
    consumerpage_address_field_country: 'Country',
    consumerpage_address_field_city: 'City',
    consumerpage_address_field_addr_line_1: 'Address Line 1',
    consumerpage_address_field_addr_line_2: 'Address Line 2',
    consumerpage_address_field_postal: 'Postal Code',

    // Consumer page: Marketing Prefs tab
    consumerpage_marketing_section_channel: 'Channel Opt-ins',
    consumerpage_marketing_section_brand: 'Brand Opt-ins',
    consumerpage_marketing_section_brand_seg: 'Brand Segmentation',
    consumerpage_marketing_field_opt_email: 'Receive Email',
    consumerpage_marketing_field_opt_sms: 'Receive SMS',
    consumerpage_marketing_field_opt_calls: 'Receive Phone Calls',
    consumerpage_marketing_field_opt_dm: 'Receive Postal Mail',
    consumerpage_marketing_field_opt_brand: 'Receive Brand Communication',
    consumerpage_marketing_field_brand: 'Brand',
    consumerpage_marketing_field_subbrand: 'Sub Brand',
    consumerpage_marketing_msg_choose_brand: 'Choose Brand',
    consumerpage_marketing_msg_choose_subbrand: 'Choose Sub Brand',
    consumerpage_marketing_msg_invalid_brand: '<Invalid Brand>',
    consumerpage_marketing_msg_invalid_subbrand: '<Invalid Sub Brand>',

    // Consumer page: Age Verification tab
    consumerpage_age_section_label_hav: 'Age Verification (HAV)',
    consumerpage_age_field_dob: 'Date of Birth',
    consumerpage_age_field_home_country: 'Home Country',
    consumerpage_age_field_hav_last_updated: 'Last Updated',
    consumerpage_age_field_hav_country: 'Country',
    consumerpage_age_field_hav_type: 'Type',
    consumerpage_age_field_hav_status: 'Status',

    // Dialogs
    dialog_btn_yes: 'Yes',
    dialog_btn_yes_confirm: 'Yes, I confirm',
    dialog_btn_no: 'No',
    dialog_btn_cancel: 'Cancel',
    dialog_get_consumer_error_title: 'Error getting consumer data.',
    dialog_get_consumer_error_text: 'Do you want to retry?',
    dialog_password_reset_title: 'Password reset',
    dialog_password_reset_text: 'Do you want to proceed?',
    dialog_consumer_delete_title: 'Consumer delete',
    dialog_consumer_delete_text: 'Do you really want to proceed?',
    dialog_unsaved_changes_title: 'Unsaved changes',
    dialog_unsaved_changes_text: 'Do you want to discard the changes?',
    dialog_save_changes_title: 'Save data',
    dialog_save_changes_text: 'Do you want to proceed?',
    dialog_last_name_change_title: 'Last name change',
    dialog_last_name_change_text:
        'You are about to change the name of this LAS, do you confirm he/she sent an identity document to prove the change?',
    dialog_set_hav_status_title: 'Setting Hard AV Status',
    dialog_set_hav_status_text: 'Do you want to proceed?',

    // Notifications messages
    msg_consumer_updated: 'Consumer updated.',
    msg_consumer_update_failed: 'Consumer update failed.',
    msg_password_reset: 'Password reset successfully.',
    msg_password_reset_failed: 'Password reset failed.',
    msg_consumer_deleted: 'Consumer deleted.',
    msg_consumer_delete_failed: 'Consumer delete failed.',
    msg_hav_status_updated: 'HAV status updated.',
    msg_hav_status_update_failed: 'HAV status update failed.',
    msg_brand_data_fetch_error: 'Brand Data fetch error.',
    msg_market_changed: 'Market changed.',
    msg_logged_out: 'Logged out.',

    // Dictionary: yes/no
    dict_yesno: {
        yes: 'Yes',
        no: 'No',
    },

    // Dictionary: gender
    dict_gender: {
        m: 'Male',
        f: 'Female',
        u: 'Unspecified',
    },

    // Dictionary: language
    dict_language: {
        en: 'English',
        fr: 'French',
        de: 'German',
        es: 'Spanish',
    },

    // Dictionary: country
    dict_country: {
        EC: 'Ecuador',
        DE: 'Germany',
        CH: 'Switzerland',
    },

    // Dictionary: address type
    dict_address_type: {
        personal: 'Personal',
    },

    // Dictionary: HAV status
    dict_hav_status: {
        VERIFIED: 'VERIFIED',
        FAILED: 'FAILED',
        NOT_VERIFIED: 'NOT VERIFIED',
        IN_PROGRESS: 'IN PROGRESS',
        RESET: 'RESET',
    },

    // Dictionary: last updated by
    dict_last_updated_by: {
        CONSUMER: 'CONSUMER',
    },

    // Dictionary: mobile verification status
    dict_mobile_status: {
        VERIFIED: 'VERIFIED',
        'NOT VERIFIED': 'NOT VERIFIED',
        INVALID: 'INVALID',
    },
};

export default messages;
